// Lead search (A6, OVERNIGHT-MORE-2026-10-03): across leads by discipline, state, consent, handled and draft status,
// on the rows the Leads view already holds -- no new tables, no new reads. And the ?lead=<id> deep link the morning
// brief has always printed for every lead, which the CRM did not read until now: it focuses that one lead.
import { draftState } from './drafts';
import { STATE_TZ } from './quietHours';

const STATE_CODES = Object.keys(STATE_TZ).sort();   // the 50 states + DC (the same list lib/leadState.js uses)

export const ANY = 'Any';
export const SEARCH_DEFAULTS = { discipline: ANY, state: ANY, consent: ANY, draft: ANY };
export const CONSENT_OPTIONS = [ANY, 'Consented', 'No consent', 'Opted out'];
export const DRAFT_OPTIONS = [ANY, 'No draft', 'Awaiting approval', 'Held', 'Sent', 'Failed the check', 'Expired', 'Rejected'];
export const STATE_OPTIONS = [ANY, 'Unknown', ...STATE_CODES];

/** The lead's discipline, normalised for grouping ('' -> '-'). */
export const disciplineOf = (l) => String((l && l.discipline) || '').trim().toUpperCase() || '-';
/** The lead's state code, or 'Unknown' for blank / not a US code. */
export const stateOf = (l) => {
  const s = String((l && l.state) || '').trim().toUpperCase();
  return STATE_CODES.includes(s) ? s : 'Unknown';
};
/** 'Opted out' wins over consent; then 'Consented' only for sms_consent === true. */
export const consentOf = (l) => (l && l.sms_opt_out === true ? 'Opted out' : l && l.sms_consent === true ? 'Consented' : 'No consent');

const DRAFT_LABEL = { awaiting: 'Awaiting approval', held: 'Held', sent: 'Sent', failed_check: 'Failed the check',
  expired: 'Expired', rejected: 'Rejected', redraft_requested: 'Rejected', redrafted: 'Rejected' };
/** The lead's newest draft as a search label, or 'No draft'. */
export const draftStatusOf = (l, draftByLead, nowMs = Date.now()) => {
  const d = draftByLead && l ? draftByLead[l.id] : null;
  return d ? DRAFT_LABEL[draftState(d, nowMs)] || 'Rejected' : 'No draft';
};

/** The disciplines present in the rows, for the select. */
export const disciplineOptions = (leads) => [ANY, ...Array.from(new Set((leads || []).map(disciplineOf))).sort()];

/** True when the lead passes every chosen filter. */
export function matchesSearch(l, q, draftByLead, nowMs = Date.now()) {
  const s = { ...SEARCH_DEFAULTS, ...(q || {}) };
  if (s.discipline !== ANY && disciplineOf(l) !== s.discipline) return false;
  if (s.state !== ANY && stateOf(l) !== s.state) return false;
  if (s.consent !== ANY && consentOf(l) !== s.consent) return false;
  if (s.draft !== ANY && draftStatusOf(l, draftByLead, nowMs) !== s.draft) return false;
  return true;
}

/** Is any search filter set? */
export const searchActive = (q) => Object.keys(SEARCH_DEFAULTS).some((k) => q && q[k] && q[k] !== ANY);

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** ?lead=<uuid> -> the id (lower case), else null. */
export function parseLeadParam(search) {
  const v = new URLSearchParams(search || '').get('lead');
  return v && UUID.test(v) ? v.toLowerCase() : null;
}
/** The link to one lead: the same shape the morning brief prints. */
export const leadHref = (id) => `?lead=${encodeURIComponent(String(id || ''))}`;
